<template>
  <div id="SendDetails">
       <DtList :orderId="orderId" @priceList="priceList"></DtList>
  </div>
</template>

<script>
import  DtList from '../common/AddRemDtList.vue'
export default {
  created() {
    //  this.orderId= this.$route.query.orderId

  },
  data() {
    return {
      orderId:170,
      DTList: []
    };
  },
  methods: {
    priceList(DTList){
      this.DTList = DTList
    }
  },
  components:{
    DtList
  }
};
</script>

<style>

</style>